import React from 'react';
import ListIcon from '@mui/icons-material/List';
import "./Header.css";
import { IconButton } from '@mui/material';
function Header() {
    return (
        <div className='header'>
            <IconButton>
                <ListIcon fontSize="large"/>
            </IconButton>
            <h2>Todo list</h2>
        </div>
    )
}
export default Header
